import { render, staticRenderFns } from "./SubscriptionsMMR.vue?vue&type=template&id=36764e70&scoped=true&"
import script from "./SubscriptionsMMR.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsMMR.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsMMR.vue?vue&type=style&index=0&id=36764e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36764e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VIcon,VLayout,VTooltip})
